import { connect } from "react-redux";

import { getOfficesShortList } from "../../OfficesNew/officesActions";
import LiveLocation from "./LiveLocation";
import { getAwayLocationList, getLatestLocationList } from "./liveLocationActions";
import { getAllMemberLastClockInOut } from "custom_modules/ClockInOut/clockInOutActions";

const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  liveLocationListLoading: state.liveLocation.latestLocationListLoading,
  liveLocationList: state.liveLocation.latestLocationList,
  awayLocationListLoading: state.liveLocation.awayLocationListLoading,
  awayLocationList: state.liveLocation.awayLocationList,
  officesShortList: state.office.officesShortList,
  onlineMembers: state.liveLocation.onlineMembers,
});

const mapDispatchToProps = dispatch => ({
  getLatestLocationList: payload => dispatch(getLatestLocationList(payload)),
  getAwayLocationList: payload => dispatch(getAwayLocationList(payload)),
  getOfficesShortList: payload => dispatch(getOfficesShortList(payload)),
  getAllMemberLastClockInOut: details =>
      dispatch(getAllMemberLastClockInOut({ ...details })),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiveLocation);
